export function readJsonStorage(key, fallback = null) {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : fallback;
  } catch {
    return fallback;
  }
}

export function clearLoginSession() {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
}

export function clearDiningSession() {
  localStorage.removeItem('diningSession');
  localStorage.removeItem('diningMember');
  localStorage.removeItem('diningTable');
}

export function clearParcelSession() {
  localStorage.removeItem('parcelSession');
  localStorage.removeItem('parcelCart');
}

export function clearPublicQrState() {
  clearLoginSession();
  clearDiningSession();
  window.dispatchEvent(new Event('userUpdated'));
}

export function isCustomerUser(user) {
  return user?.role === 'customer';
}

export function hasDiningSession() {
  return Boolean(readJsonStorage('diningSession')?.sessionCode);
}

export function hasParcelSession() {
  return Boolean(readJsonStorage('parcelSession')?.sessionId);
}

export function canUseDineInCart() {
  return isCustomerUser(readJsonStorage('user')) || hasDiningSession();
}
